// EstimateForm is used to populate preset values before submitting the form
//
// Usage:
//
// EstimateForm.init($('.js-estimate-form'));
//

// Note: To avoid code duplication, assumes that MaterialForm is globally available
// via /app/assets/javascripts/application.js
/* eslint-disable no-undef */
import { ScrollToElement } from "./scroll_to_element";

const EstimateForm = {
  init($container, refreshPackagePreset) {
    EstimateForm.populatePackagePreset($container, refreshPackagePreset);
    EstimateForm.showTariffFields($container);
    EstimateForm.showAddress($container);
    EstimateForm.showDimensions($container);
    EstimateForm.showSizeDimensions($container, true);
    EstimateForm.disableRequiredFieldValidations($container);

    $container.on("change", ".js-estimate-country .js-material-form__control", function() {
      EstimateForm.showTariffFields($container);
      EstimateForm.showAddress($container);
      EstimateForm.clearPostalCodeField($container);
    });

    $container.on("change", ".js-package-select", function() {
      EstimateForm.populatePackagePreset($container, true);
      EstimateForm.showDimensions($container);
    });

    $container.on("change", ".js-package-type", function() {
      EstimateForm.showSizeDimensions($container, false);
    });

    // Prevent autocomplete on postal fields
    $container.find("input[autocomplete='postal-code']").attr("autocomplete", "new-password");

    // Disable postal code format validation, let that run in the view model
    $container.find("input#estimate_view_model_postal_code").removeAttr("data-validates-postal-code-format");
    $container.find("input#estimate_view_model_postal_code_can").removeAttr("data-validates-postal-code-format");
    $container.find("input#estimate_view_model_postal_code_us").removeAttr("data-validates-postal-code-format");

    // Remove default submit handler
    setTimeout(function() {
      $(".js-material-form").off("submit");
    }, 250);

    $container.on("submit", EstimateForm.handleSubmit);
    // Move to errors
    EstimateForm.scrollToErrors();
  },

  clearPostalCodeField($container) {
    $container.find(".js-postal-code input").val("");
  },

  disableRequiredFieldValidations($container) {
    // Disable client side validation for non CA/US postal code field as postal
    // code is not required for international addresses.
    $container.find("input#estimate_view_model_postal_code").removeAttr("data-validates-presence");

    // Disable street, city, province client side validations and let server
    // side validations handle it for now.
    $container.find(".js-custom-address-fields").find("input,select").removeAttr("data-validates-presence");
  },

  showTariffFields($container) {
    var country = $container.find(".js-estimate-country .js-material-form__control").val();
    var $tariffFields = $container.find(".js-tariff-fields");
    var $packageSelect = $container.find(".js-package-select");
    var $packageSelectItem = $packageSelect.find(":selected");
    var $valueAmount = $container.find(".js-value-amount");
    if (EstimateForm.isCountryUs(country)) {
      $tariffFields.show();
    } else {
      $tariffFields.hide();
      // Set value amount to that of selected item to pass validation, or 1 if blank (custom could be blank)
      $valueAmount.val($packageSelectItem.data("value-amount"));
      if (!$valueAmount.val()) {
        $valueAmount.val("1").parent().addClass("is-focused");
      }
    }
  },

  isCountryUs(country) {
    return ["US", "AS", "GU", "MP", "PR", "UM", "VI"].includes(country);
  },

  showAddress($container) {
    var $calculatorSuggestion = $container.find(".js-calculator-suggestion");
    var country = $container.find(".js-estimate-country .js-material-form__control").val();
    if (country == "CA" || country == "US" || country == "") {
      $container.find(".js-custom-address-fields").removeClass("custom-address-fields__visible");
      $calculatorSuggestion.show();
    } else {
      $container.find(".js-custom-address-fields").addClass("custom-address-fields__visible");
      $calculatorSuggestion.hide();
    }
  },

  showDimensions($container) {
    var $customPackageFields = $container.find(".js-custom-package-fields");
    var $packageSelect = $container.find(".js-package-select");
    var $packageSelectItem = $packageSelect.find(":selected");
    if ($packageSelectItem.data("is-custom")) {
      $customPackageFields.show();
    } else {
      $customPackageFields.hide();
    }
  },

  showSizeDimensions($container) {
    var $packageType = $container.find(".js-package-type").val();
    var $dimensionFields = $container.find(".js-custom-package-dimensions");
    var $sizeXAmount = $container.find(".js-size-x-amount");
    var $sizeYAmount = $container.find(".js-size-y-amount");
    var $sizeZAmount = $container.find(".js-size-z-amount");

    if ($packageType == "thick_envelope" || $packageType == "parcel") {
      $dimensionFields.show();
    } else {
      $dimensionFields.hide();
      // Enter holder value to pass validation
      if (!$sizeXAmount.val()) {
        $sizeXAmount.val("10").parent().addClass("is-focused");
      }
      if (!$sizeYAmount.val()) {
        $sizeYAmount.val("10").parent().addClass("is-focused");
      }
      if (!$sizeZAmount.val()) {
        $sizeZAmount.val("10").parent().addClass("is-focused");
      }
    }
  },

  populatePackagePreset($container, refreshPackagePreset) {
    var $packageSelect = $container.find(".js-package-select");
    var $packageSelectItem = $packageSelect.find(":selected");
    var $packageType = $container.find(".js-package-type");
    var $weightAmount = $container.find(".js-weight-amount");
    var $weightUnit = $container.find(".js-unit-weight");
    var $sizeXAmount = $container.find(".js-size-x-amount");
    var $sizeYAmount = $container.find(".js-size-y-amount");
    var $sizeZAmount = $container.find(".js-size-z-amount");
    var $sizeUnit = $container.find(".js-unit-size");
    var $originCountry = $container.find(".js-origin-country");
    var $hsTariffCode = $container.find(".js-hs-tariff-code");
    var $valueAmount = $container.find(".js-value-amount");

    $(".js-estimate-form__empty-dropdown .is-present").removeClass("is-present");

    // Refresh preset information on initial page load or when preset is changed
    if (refreshPackagePreset) {
      $packageType.val($packageSelectItem.data("package-type"));
      $weightAmount.val($packageSelectItem.data("weight-amount"));
      $weightUnit.val($packageSelectItem.data("weight-unit"));
      $sizeXAmount.val($packageSelectItem.data("size-x-amount"));
      $sizeYAmount.val($packageSelectItem.data("size-y-amount"));
      $sizeZAmount.val($packageSelectItem.data("size-z-amount"));
      $sizeUnit.val($packageSelectItem.data("size-unit"));
      $originCountry.val($packageSelectItem.data("origin-country")).trigger("change");
      $hsTariffCode.val($packageSelectItem.data("hs-tariff-code"));
      $valueAmount.val($packageSelectItem.data("value-amount"));
    }
  },

  scrollToErrors() {
    // Scroll to first invalid elment
    var firstElement = $(".is-invalid:visible").first();
    if (firstElement) {
      ScrollToElement.scroll(firstElement, 1000);
    }
  },

  handleSubmit(event) {
    if (MaterialForm.validateForm($(this))) {
      $(".js-estimate-form__loader").addClass("d-flex");
      return true;
    }
    EstimateForm.scrollToErrors();
    event.preventDefault();
    event.stopPropagation();

    return false;
  }
};

export { EstimateForm };
